"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.match");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _anchorReport = require("@/api/anchorReport");
// import { anchorBrokerIncome } from '@/api/broker'
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    rateFilter: function rateFilter(val) {
      console.log(val);
      return (val * 100).toFixed(2);
    }
  },
  data: function data() {
    return {
      pcshow: true,
      listLoading: false,
      list: [],
      total: 0,
      times: [],
      listQuery: {
        page: 1,
        size: 10,
        startTime: '',
        endTime: '',
        anchor_id: '',
        country_code: ''
      },
      startTime: '',
      endTime: ''
    };
  },
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    },
    startTime: function startTime(val) {
      this.startTime = val;
      this.listQuery.startTime = val;
    },
    endTime: function endTime(val) {
      this.endTime = val;
      this.listQuery.endTime = val;
    }
  },
  created: function created() {
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      this.pcshow = false;
    } else {
      this.pcshow = true;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$brokerAnchorRe, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _anchorReport.brokerAnchorReportList)(this.listQuery);
            case 1:
              _yield$brokerAnchorRe = _context.v;
              code = _yield$brokerAnchorRe.code;
              data = _yield$brokerAnchorRe.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.total = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleFilter: function () {
      var _handleFilter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.listQuery.page = 1;
              this.getList();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleFilter() {
        return _handleFilter.apply(this, arguments);
      }
      return handleFilter;
    }(),
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      date = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date)[0];
      return date;
    }
  }
};